var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreyHead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3235_2849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.44456 20.0402C1.50456 20.3702 1.62456 20.6802 1.93456 20.8102C3.50456 21.4802 7.77456 23.3202 12.2546 23.2502C16.7346 23.1802 23.3346 20.8102 25.4446 20.0102C25.8346 19.8602 26.0446 19.4502 25.9446 19.0502C25.2946 16.4102 23.1046 9.78016 24.3346 5.79016C24.3546 5.73016 24.3646 5.67016 24.3546 5.61016V5.39016C24.3146 4.35016 23.6346 3.43016 22.6346 3.12016L16.3746 1.11016C15.3246 1.04016 12.9946 0.980156 11.9546 0.910156L3.41456 2.72016C2.10456 2.96016 1.63456 3.96016 1.17456 5.20016C1.17456 5.20016 0.31456 14.0702 1.44456 20.0302V20.0402Z",
    fill: "url(#paint0_linear_3235_2849)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1552 8.10008L23.4452 7.39008C23.5252 7.35008 23.6052 7.33008 23.6952 7.33008H24.1852C24.3152 7.33008 24.4452 7.38008 24.5352 7.47008L24.7052 7.64008C24.8052 7.74008 24.8652 7.88008 24.8552 8.02008L24.7652 11.8801C24.7652 11.9901 24.7252 12.1001 24.6552 12.1901L24.0252 12.9701C23.8852 13.1401 23.6652 13.2001 23.4552 13.1301L22.4952 12.7901C22.3052 12.7201 22.1752 12.5501 22.1552 12.3501L21.8952 8.60008C21.8852 8.40008 21.9852 8.22008 22.1552 8.12008V8.10008Z",
    fill: "url(#paint1_linear_3235_2849)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.97469 8.09008L1.73469 7.40008C1.65469 7.35008 1.55469 7.33008 1.46469 7.33008H1.01469C0.864687 7.33008 0.724687 7.39008 0.624687 7.49008L0.484688 7.63008C0.364688 7.73008 0.304688 7.88008 0.304688 8.04008L0.394688 11.8601C0.394688 11.9801 0.444687 12.1001 0.514687 12.2001L1.10469 12.9401C1.25469 13.1301 1.50469 13.2001 1.73469 13.1201L2.62469 12.8001C2.83469 12.7301 2.98469 12.5301 2.99469 12.3101L3.25469 8.63008C3.27469 8.41008 3.15469 8.21008 2.96469 8.10008L2.97469 8.09008Z",
    fill: "url(#paint2_linear_3235_2849)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7347 4.42969H4.99469C3.64469 4.42969 2.55469 5.51969 2.55469 6.86969V11.9797C2.55469 14.4897 3.95469 16.7797 6.18469 17.9297L9.66469 19.7297C11.5947 20.7297 13.8847 20.7297 15.8147 19.7297L19.2947 17.9297C21.5247 16.7797 22.9247 14.4797 22.9247 11.9797V6.86969C22.9247 5.51969 21.8347 4.42969 20.4847 4.42969H12.7447H12.7347Z",
    fill: "url(#paint3_linear_3235_2849)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.594 13.0605C12.034 13.1505 12.994 13.3105 13.814 13.1105C13.904 13.0905 13.964 13.1905 13.904 13.2605C13.574 13.5805 13.024 14.1005 12.754 14.2005C12.454 14.3005 11.814 13.5805 11.514 13.2105C11.464 13.1405 11.514 13.0505 11.604 13.0705L11.594 13.0605Z",
    fill: "url(#paint4_linear_3235_2849)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9141 8.42963L15.0141 9.10963L19.3541 8.48963C19.4841 8.46963 19.6141 8.48963 19.7341 8.53963L21.0141 9.10963V8.92963L19.7541 8.25963C19.6441 8.19963 19.5141 8.16963 19.3941 8.17963L14.9141 8.42963Z",
    fill: "#3E393D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1855 10.0508H20.5555C20.5555 10.0508 19.7255 12.0808 17.7355 12.0908C15.7455 12.1008 15.1855 10.0508 15.1855 10.0508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8741 11.1707C18.4041 11.1707 18.8441 10.7407 18.8441 10.2007C18.8441 10.1207 18.8341 10.0407 18.8141 9.9707H16.9441C16.9241 10.0507 16.9141 10.1207 16.9141 10.2007C16.9141 10.7307 17.3441 11.1707 17.8841 11.1707H17.8741Z",
    fill: "#2A2A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9041 9.79102L15.1641 10.001C15.1641 10.001 15.1641 10.021 15.1841 10.051H20.5541C20.6041 9.95102 20.9041 9.79102 20.9041 9.79102Z",
    fill: "#3E393D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5844 8.42936L10.4844 9.10936L6.19438 8.49936C6.02438 8.47936 5.86438 8.49936 5.70438 8.56936L4.48438 9.10936V8.92936L5.69438 8.28936C5.83438 8.20936 5.99438 8.17936 6.15438 8.18936L10.5744 8.42936H10.5844Z",
    fill: "#3E393D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3153 10.0508H4.94531C4.94531 10.0508 5.77531 12.0808 7.76531 12.0908C9.75531 12.1008 10.3153 10.0508 10.3153 10.0508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6243 11.1707C7.0943 11.1707 6.6543 10.7407 6.6543 10.2007C6.6543 10.1207 6.6643 10.0407 6.6843 9.9707H8.5543C8.5743 10.0507 8.5843 10.1207 8.5843 10.2007C8.5843 10.7307 8.1543 11.1707 7.6143 11.1707H7.6243Z",
    fill: "#2A2A41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48438 9.76953L10.3344 10.0095C10.3344 10.0095 10.3344 10.0295 10.3144 10.0595H4.94438C4.89438 9.95953 4.48438 9.76953 4.48438 9.76953Z",
    fill: "#3E393D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98509 4.4297C4.98509 4.4297 8.49509 6.7597 9.97509 7.1097C11.4551 7.4597 12.7051 7.3197 12.7051 7.3197C12.7051 7.3197 11.8851 6.3397 12.1151 5.9897C12.3451 5.6397 14.7751 7.3197 17.5551 7.3197C17.5551 7.3197 16.7951 6.6897 17.2051 6.3397C17.2051 6.3397 19.7251 7.4997 20.9351 7.7997C22.1451 8.0997 22.8951 11.9797 22.8951 11.9797C22.8951 11.9797 24.1151 5.6397 22.8951 4.4297C21.6751 3.2197 5.17509 2.5697 3.70509 3.2297C2.23509 3.8897 2.10509 8.6197 2.55509 11.3697C2.55509 11.3697 4.28509 4.2397 4.99509 4.4397L4.98509 4.4297Z",
    fill: "#3E393D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3235_2849",
    x1: 13.4246,
    y1: 3.27016,
    x2: 13.4246,
    y2: 22.7602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E393D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3F3B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#464245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#514E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#626061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3235_2849",
    x1: 23.4352,
    y1: 7.01008,
    x2: 23.2152,
    y2: 13.4101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C18988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CF9C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DFB3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECC4B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F5D0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FAD8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3235_2849",
    x1: 1.72469,
    y1: 6.93008,
    x2: 1.93469,
    y2: 13.3201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C18988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CF9C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DFB3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECC4B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F5D0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FAD8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3235_2849",
    x1: 12.7347,
    y1: 4.28969,
    x2: 12.7347,
    y2: 17.6597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C18988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CF9C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DFB3AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#ECC4B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F5D0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FAD8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCDACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3235_2849",
    x1: 12.704,
    y1: 13.3105,
    x2: 12.684,
    y2: 14.6405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCDACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#C18988"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3235_2849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.67,
    height: 22.34,
    fill: "white",
    transform: "translate(0.304688 0.910156)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyHead);
export default __webpack_public_path__ + "static/media/grey_head.cd73a4156e43635646af5b71a9347b68.svg";
export { ForwardRef as ReactComponent };